<template>
    <b-modal :visible="visible && clientList?.length > 0" scrollable centered no-close-on-backdrop no-close-on-esc hide-footer :title="$t('DbSelection')" title-class="text-primary" header-class="border-0 pb-0" body-class="pb-2 mx-2" >
        <template #modal-header="{close}">
            <b-row class="w-100 p-0 m-0 h-100" align-v="center">
                <b-col cols="auto" class="text-center">
                    <h5 class="text-primary font-weight-bold ">{{ $tc('AvailableClientAccounts', clientList?.length) }}</h5><!--  Sélectionnez une base -->
                </b-col>
                <b-col class="text-center" align-v="center">
                    <b-form-checkbox v-model="hasFullRightMode" switch >{{ $t('FullControl') }}</b-form-checkbox> 
                </b-col>
                <b-col  cols="auto" class="pr-0 p-1 text-right">
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close(); visible = false; clientList = null" v-b-tooltip.hover :title="$t('Close')" /><!-- Fermer -->
                </b-col>
            </b-row>
        </template>
    
        <b-row v-for="(client, index) in clientList" :key="'ClientLine_' + index" @click="goImpersonate(client.Id)" class="clientLine position-relative rounded px-1 py-1 mb-1 bg-gray-middle-dark">
            <b-col class="d-inline-block text-left py-0 px-2 align-middle">{{ client.Name }}</b-col>
            <b-col :class="['d-inline-block text-right py-0 px-1 rounded text-center align-middle bg-white', {'font-weight-bold': client.Profil === $t('Administrator') }]">{{ client.Profil }}</b-col>
        </b-row>

        <div id="iframeSync" class="d-none">
            <iframe :src="iframeTarget" @load="iframeLoaded" style="border: none"></iframe>
        </div>
    </b-modal>    
</template>

<script lang="ts">
import {Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import axios from 'axios';
import { API_URL } from '@/App.settings';
import Dictionary from '@/types/Dictionary';
import locales from "./locales/ClientList.json";
import { I18nUtils, VueSyncHandler } from './Utils';
import { Getter } from 'vuex-class';


/** Liste des utilisateurs clients */
@Component({
    i18n: { messages: locales }
})
export default class ClientList extends mixins(VueSyncHandler, I18nUtils) {
    /** Indique si le composant est affiché ou non */
    @PropSync("Visible", { default : () => false })
    public visible!: boolean;

    @Prop({ default: () => 0 })
    public ConnectionId : number;

    /** Information si utilisateur superviseur */
    @Getter('SessionStore/GetUserIsSupervisor')
    private isUserSupervisor : boolean;

    /** Inforamtion de l'identifiant du profil de l'utilisateur courant */
    @Getter('SessionStore/GetProfileId')
    private profileId : number;

    /** Liste des utilisateurs */
    private clientList : {Id : number, Name: string, Profil: string}[] = [];

    /** Indication si on souhaite se connecter en tant qu'un utilisateur avec les droits maximum appliqués sur cet utilisateur */
    private hasFullRightMode : boolean = false;

    iframeLoaded() {
        console.debug("ClientList - IFrameLoaded - iFrameTarget : %O - redirect", this.iframeTarget, this.redirect);
    }

    /**
     * Permet de se connecter à la place d'un client
     * @param clientId identifiant du client
     */
    private goImpersonate(clientId: number){
        // Récupération de la liste des clients
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["ConnectionId"] = this.ConnectionId;
        args["ClientId"] = clientId;
        args["HasFullRightMode"] = this.hasFullRightMode;

        this.$store.dispatch("ShowLoadingMask", this.$t('ConnectionInProgress'));   // "Connexion en cours...");

        axios.post(API_URL + "Connexion/Impersonate", args).then((response) => {
            if (response.data) {
                this.$store.dispatch("ShowLoadingMask", this.$t('DatabaseSync'));   //"Synchronisation de la base...");

                Vue.set(this, "redirect", "/Master");
                this.handleMessage(response.data.iK, response.data.access_token);
            }
        }).catch(err => {
			console.error(err);
			this.$bvToast.toast(this.$t('AnErrorOccuredContactAdmin').toString(), {     /* "Une erreur est survenue. Veuillez contacter votre administrateur." */
				title: this.$t('ConnectionFailure').toString(),     //"Erreur de connexion",
				autoHideDelay: 10000,
				variant: "danger",
				solid: true,
				appendToast: true,
				toaster: "b-toaster-top-center"
			});
        }).finally(() => {
            this.$store.dispatch("HideLoadingMask", {});
        });
    }

    created(){
        /** Gère la langue des textes affichés dans le composant */
        this.handleComponentLocale();

        // Récupération de la liste des clients
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["ConnectionId"] = this.ConnectionId;

        this.$store.dispatch("ShowLoadingMask", this.$t('UserListLoading'));    // "Chargement des utilisateurs..."
        axios.post(API_URL + "Connexion/GetClientList", args).then(response => {
            if(response.data){
                this.clientList = response.data;

                // Filtre la liste pour les admin
                if(!this.isUserSupervisor && this.profileId == 1)
                    this.clientList = this.clientList.filter(c => c.Profil != this.$t('Administrator'))

            }
        }).catch(err => {
			console.error(err);
			this.$bvToast.toast(this.$t('AnErrorOccuredContactAdmin').toString(), {     // "Une erreur est survenue. Veuillez contacter votre administrateur."
				title: this.$t('Error').toString(),  //   "Erreur"
				autoHideDelay: 10000,
				variant: "danger",
				solid: true,
				appendToast: true,
				toaster: "b-toaster-top-center"
			});
		})
        .finally(() => {
            this.$store.dispatch("HideLoadingMask", {});
        });
    }

    beforeDestroy() {
        if (this.unwatchLanguage)
            this.unwatchLanguage();
    }
}
</script>

<style scoped>
    .clientSelection {
        min-width: 600px;
        padding-top: 50px;
        padding-bottom: 10px;
        padding-left: 20px;
        padding-right: 20px;
    }

    .clientLine:hover {
        /* Passer par le variant ? */
        background: var(--secondary) !important;
        cursor: pointer;
    }

    /** Pour changement de la couleur du texte du nom du client en hover */
    .clientLine:hover span:first-child {
        color: white;
    }

    .cancelClientSelection:hover {
        /* Passer par le variant ? */
        background-color: var(--secondary) !important;
        cursor: pointer;
    }
</style>